import { apiClientFactory } from '@vue-storefront/core';
import type { Endpoints } from './types';
import { tokenExtension } from './api.extention';

import axios from 'axios';
import * as api from './api';

type ClientConfig = {
  client: any;
  config: any;
  auth: any;
  cookie: any;
  api: any;
}

const init = (settings: ClientConfig): any => {
  axios.defaults.withCredentials = true;
  axios.defaults.timeout = 3000;
  const client = axios.create({
    baseURL: settings.api.url
  });

  if (!settings.api.url) {
    throw new Error('未配置api地址:settings.api.url');
  }

  // eslint-disable-next-line no-debugger
  // console.warn('createa aoix client', settings);

  return {
    config: settings,
    client
  };
};

function onCreate(settings) {
  if (!settings?.client) {
    return init(settings);
  }

  return {
    config: settings,
    client: settings.client
  };
}

const { createApiClient } = apiClientFactory<ClientConfig, Endpoints>({
  onCreate,
  api,
  extensions: [tokenExtension]
});

export {
  createApiClient,
  init
};
